export default function Footer() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-ink-50">
      {/* Main footer */}
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          {/* Left: Brand info */}
          <div className="md:col-span-5">
            <div className="mb-6">
              <img
                src="https://storage.readdy-site.link/project_files/b101d8e3-eb8f-4b23-a967-4f4a49b8c766/ec3f985d-0f8e-4388-91aa-732955220d2f_logo.png?v=4e906732bd7f67cbda67b434e6bd272b"
                alt="温泉民宿宝栄丸"
                className="h-12 md:h-14 w-auto object-contain"
              />
            </div>
            <address className="space-y-2 text-sm text-stone-600 leading-relaxed not-italic">
              <p>〒413-0411 静岡県賀茂郡東伊豆町稲取965</p>
              <p>
                TEL:{" "}
                <a
                  href="tel:0557-95-1813"
                  className="hover:text-warm-700 transition-colors"
                >
                  0557-95-1813
                </a>
              </p>
              <p>伊豆稲取駅より徒歩15分</p>
              <p>年中無休 / 客室3室</p>
            </address>

            {/* Newsletter */}
            {/* Newsletter section removed */}
          </div>

          {/* Right: Links */}
          <div className="md:col-span-7">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-8 gap-y-3">
              {/* Column 1 */}
              <div className="space-y-3">
                <a
                  href="#rooms"
                  onClick={(e) => { e.preventDefault(); scrollTo("#rooms"); }}
                  className="block text-sm text-stone-600 hover:text-warm-700 transition-colors cursor-pointer"
                >
                  お部屋
                </a>
                <a
                  href="#onsen"
                  onClick={(e) => { e.preventDefault(); scrollTo("#onsen"); }}
                  className="block text-sm text-stone-600 hover:text-warm-700 transition-colors cursor-pointer"
                >
                  温泉・施設
                </a>
                <a
                  href="#access"
                  onClick={(e) => { e.preventDefault(); scrollTo("#access"); }}
                  className="block text-sm text-stone-600 hover:text-warm-700 transition-colors cursor-pointer"
                >
                  アクセス
                </a>
              </div>

              {/* Column 2 */}
              <div className="space-y-3">
                <a
                  href="tel:0557-95-1813"
                  className="block text-sm text-stone-600 hover:text-warm-700 transition-colors cursor-pointer"
                >
                  ご予約
                </a>
              </div>

              {/* Column 3 removed */}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-stone-200">
        <div className="max-w-6xl mx-auto px-4 md:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-stone-500">
            &copy; 2026 温泉民宿宝栄丸 All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            {/* Legal links removed */}
          </div>
        </div>
      </div>
    </footer>
  );
}